module.exports = __webpack_public_path__ + "assets/69f58b3c2cff5df8df289e59362c610e.gif";